
      window.addEventListener('readystatechange', checkForTestFeatures);
      window.addEventListener('hashchange',       checkForTestFeatures);
      window.addEventListener('popstate',         checkForTestFeatures);
      window.setTimeout(                          checkForTestFeatures, 10e3);
      function checkForTestFeatures()
      {
        if (window.location.hash === '#test-features' || unescape(window.location.href).endsWith('#test-features'))
          document.body.setAttribute('test-features', 'enabled');
      }
      if (document.body)
        checkForTestFeatures();
    